<template>
  <!-- 专区列表管理 -->
  <div class="prefectureList">
    <!-- 面包屑导航 -->
    <crumbs-bar
      @refresh="handleRefresh"
      :crumbsList="['专区管理', $route.meta.title]"
    >
      <template slot="controls">
        <el-link
          @click="explain = true"
          style="margin-right: 10px"
          icon="el-icon-question"
          :underline="false"
          type="warning"
          >操作说明</el-link
        >
        <el-button type="primary" icon="el-icon-s-home" @click="homeBrand"
          >首页品牌</el-button
        >
        <el-button
          type="primary"
          icon="el-icon-circle-plus-outline"
          @click="handleEdit('')"
          >新增品牌</el-button
        >
        <el-button type="danger" @click="handleDel()">删除</el-button>
      </template>
    </crumbs-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <label class="label">是否启用：</label>
        <el-select
          placeholder="是否启用"
          style="width: 100px; margin-right: 5px"
          v-model="searchForm.status"
        >
          <el-option
            v-for="(item, index) in stausList"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-input
          style="width: 200px; margin-right: 5px"
          clearable
          placeholder="输入编号/名称"
          v-model="searchForm.name"
        ></el-input>
        <el-button type="primary" @click="seach" icon="el-icon-search"
          >搜索</el-button
        >
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 130px)"
      tooltip-effect="dark"
      style="width: 100%"
      @selection-change="selectionChange"
    >
      <el-table-column type="selection" align="center" width="55">
      </el-table-column>
      <el-table-column label="序号" align="center" width="50">
        <template slot-scope="scope">
          <span>{{ (currPage - 1) * pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="entName"
        show-overflow-tooltip
        label="机构名称"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="id"
        show-overflow-tooltip
        label="品牌编号"
      >
      </el-table-column>
      <el-table-column
        prop="name"
        align="center"
        show-overflow-tooltip
        label="品牌名称"
      >
      </el-table-column>
      <el-table-column
        prop="type"
        label="类别"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="sort"
        label="排序"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="time"
        label="创建日期"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-tag type="warning" v-if="scope.row.status == 1">已下架</el-tag>
          <el-tag type="success" v-if="scope.row.status == 2">已上架</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="des"
        label="备注"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column label="操作" width="140" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.status == '1'">
            <el-button
              type="success"
              @click="changeStatus(scope.row, 2)"
              style="padding: 2px 3px"
              plain
              >上架</el-button
            >
            <el-button
              type="primary"
              @click="handleEdit(scope.row)"
              style="padding: 2px 3px"
              plain
              >编辑</el-button
            >
            <!-- <el-button type="danger" @click="changeStatus(scope.row,0)" style="padding:2px 3px;" plain>删除</el-button> -->
          </div>
          <el-button
            v-if="scope.row.status == '2'"
            type="warning"
            @click="changeStatus(scope.row, 1)"
            style="padding: 2px 3px"
            plain
            >下架</el-button
          >
          <el-button
            type="primary"
            style="padding: 2px 3px"
            plain
            @click="handleBrand(scope.row)"
            >品牌商品</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>
    <!-- 新增品牌 -->
    <el-drawer
      title=""
      :visible.sync="addDrawer"
      :withHeader="false"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      :wrapperClosable="$store.state.closeOnClickModal"
      direction="rtl"
    >
      <div class="drawer-header">品牌信息</div>
      <el-scrollbar style="height: calc(100% - 90px)">
        <div class="drawer-form-wrap">
          <el-form
            :model="addForm"
            label-position="rigth"
            label-width="100px"
            :rules="formRule"
            ref="addForm"
          >
            <el-form-item label="品牌名称" prop="name">
              <el-input v-model="addForm.name" clearable></el-input>
            </el-form-item>
            <el-form-item label="品牌图片" prop="brandImg">
              <img-view :imgList="[{ url: img_url, id: 0 }]"> </img-view>
              <upload accept="image/*" @fileChange="fileChange"></upload>
              <div>参考尺寸200px*100px</div>
            </el-form-item>
            <!-- <el-form-item label="图片链接" prop="imgUrl">
              <el-input v-model="addForm.imgUrl" clearable></el-input>
            </el-form-item> -->
            <el-form-item label="详情图片" prop="detailsImg">
              <img-view :imgList="[{ url: img_url1, id: 0 }]"> </img-view>
              <upload accept="image/*" @fileChange="fileChange2"></upload>
              <div>参考尺寸400px*400px</div>
            </el-form-item>
            <el-form-item label="描述" prop="des">
              <el-input v-model="addForm.des" clearable></el-input>
            </el-form-item>
            <el-form-item label="排序" prop="sort">
              <el-input-number
                v-model="addForm.sort"
                :min="1"
                :controls="false"
                style="width: 100%"
              ></el-input-number>
            </el-form-item>
          </el-form>
        </div>
      </el-scrollbar>
      <div class="drawer-footer">
        <el-button type="primary" @click="submitForm">确定</el-button>
        <el-button type="info" @click="clearForm">取消</el-button>
      </div>
    </el-drawer>

    <el-dialog
      title="操作说明"
      :visible.sync="explain"
      :close-on-click-modal="$store.state.closeOnClickModal"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      width="70%"
    >
      <div class="explain-text">
        <p>维护药品品牌信息</p>
        <p>新增品牌：添加商品品牌信息</p>
        <p>首页品牌：控制要显示在App首页和PC首页的品牌</p>
        <p>
          品牌商品：和商品列表中商品进行绑定，在PC商城和App商城中查看该品牌商品时展示
        </p>
        <p>下架：下架后品牌将不会在商城中显示，下架的品牌可进行编辑删除</p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
//表单验证
import { mustFill } from "@/mixins/data/valid.js";

export default {
  name: "prefectureList",
  data() {
    return {
      /**表格数据 */
      // {
      //   entId: '机构ID',
      //   entName: '机构名称',
      //   id: '品牌编号',
      //   name: '品牌名称',
      //   type: '类别',
      //   sort: '排序',
      //   time: '创建日期',
      //   status: '状态',
      //   des: '备注',
      // }
      tableData: [],
      searchForm: {
        /**搜索表单 */ status: "9",
        name: "",
      },
      img_url: "",
      img_url1: "",
      stausList: [
        {
          value: "9",
          label: "全部",
        },
        {
          value: "1",
          label: "未上架",
        },
        {
          value: "2",
          label: "已上架",
        },
      ],
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
      addDrawer: false /**新增品牌drawer */,
      /**表单数据 */
      //品牌名称 品牌图片 图片链接 品牌详情图片 备注 首页品牌推荐 排序
      addForm: {
        id: "",
        name: "",
        brandImg: "",
        imgUrl: "",
        detailsImg: "",
        des: "",
        sort: "",
      },
      formRule: {
        /**表单验证 */ name: [mustFill],
        // imgUrl: [mustFill],
        sort: [mustFill],
      },

      /**使用说明 */
      explain: false,
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    seach() {
      this.getTableData(1);
    },
    /**获取表格数据 */
    getTableData(num) {
      this.currPage = num == 1 ? 1 : this.currPage;
      let data = {
        type: "Query_Brand",
        status: this.searchForm.status,
        strWhere: this.searchForm.name,
        PageIndex: this.currPage,
        PageSize: this.pageSize,
      };
      let proc = "Proc_Admin_Brand"; //存储过程名
      let type = "ReturnList";
      this.$requestSys({
        method: "post",
        url:
          "brand/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        dataType: "json",
      })
        .then((res) => {
          console.log(res);
          this.tableData = [];
          if (res.flag == 0) {
            this.allPage = res.recordCount;
            this.tableData = res.data.map((item) => ({
              entId: item.entId,
              entName: item.entname,
              id: item.billno,
              name: item.name,
              type: item.faType,
              sort: item.sort_id,
              time: item.add_time,
              status: item.status,
              des: item.beizhu,
            }));
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },
    /**刷新表格数据 */
    handleRefresh() {
      this.getTableData();
    },
    homeBrand() {
      this.$router.push("homeBrand");
    },
    // 获取单个详细信息
    getbrankDetail(row, lsid) {
      var json = {
        type: "BrandEditor_Query",
        lsid: lsid,
        billno: row.id,
      };
      var proc = "Proc_Admin_Brand"; //存储过程名
      var type = "ReturnList";
      this.$requestSys({
        method: "post",
        url:
          "brand/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(json)) +
          "&proc=" +
          proc,
        dataType: "json",
      })
        .then((res) => {
          if (res.flag == 0) {
            this.addForm.id = res.data[0].billno;
            this.addForm.name = res.data[0].name;
            this.addForm.imgUrl = res.data[0].linkUrl;
            this.addForm.brandImg = res.data[0].img_url;
            this.addForm.detailsImg = res.data[0].img_url_dt;
            this.addForm.des = res.data[0].beizhu;
            this.addForm.sort = res.data[0].sort_id;
            this.img_url = this.$setImgUrl(res.data[0].img_url);
            this.img_url1 = this.$setImgUrl(res.data[0].img_url_dt);
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**客户 selection change触发事件 */
    selectionChange(section) {
      this.selectedList = section;
    },
    /**删除 */
    handleDel() {
      let row = {};
      if (this.selectedList.length == 1) {
        // this.$confirm("确定删除吗?", "提示", {
        //   confirmButtonText: "确定",
        //   cancelButtonText: "取消",
        //   type: "error",
        // })
        //   .then(() => {
        row = this.selectedList[0];
        this.changeStatus(row, 0);
        //     })
        //     .catch(() => {});
        // } else {
        //   this.$message({
        //     message: "只能删除一条数据",
        //     type: "warning",
        //   });
      }
    },
    // 删除，上下架
    changeStatus(row, status) {
      let msg = "确定要执行操作吗?";
      let msgType = "info";
      if (status == 1) {
        msg = "确定下架吗?";
        msgType = "warning";
      } else if (status == 2) {
        msg = "确定上架吗?";
        msgType = "success";
      } else if (status == 0) {
        msg = "确定删除吗?";
        msgType = "error";
      }
      this.$confirm(msg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: msgType,
      })
        .then(() => {
          let proc = "Proc_Admin_Brand"; //存储过程名
          let type = "ReturnNumber";
          let json = {
            type: "AuditBrandStatus",
            billno: row.id,
            status: status,
          };
          this.$requestSys({
            method: "post",
            url:
              "brand/ashx/ReturnJson.ashx?type=" +
              type +
              "&json=" +
              encodeURIComponent(JSON.stringify(json)) +
              "&proc=" +
              proc,
            dataType: "json",
          })
            .then((res) => {
              if (res.flag == 0) {
                this.$message({
                  message: res.message,
                  type: "success",
                });
                this.getTableData();
              } else {
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              window.console.log(err);
            });
        })
        .catch(() => {});
    },
    /**upload上传回调 */
    fileChange(file) {
      let formData = new FormData();
      file.forEach((ele, index) => {
        formData.append("file" + index, ele);
      });
      this.$uploadRequest({
        url: "admin/ashx/UploadImg.ashx?type=UploadImage&imgType=brand",
        method: "post",
        data: formData,
      })
        .then((res) => {
          this.addForm.brandImg = res.message;
          this.img_url = this.$setImgUrl(res.message);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    fileChange2(file) {
      let formData = new FormData();
      file.forEach((ele, index) => {
        formData.append("file" + index, ele);
      });
      this.$uploadRequest({
        url: "admin/ashx/UploadImg.ashx?type=UploadImage&imgType=brand",
        method: "post",
        data: formData,
      })
        .then((res) => {
          this.addForm.detailsImg = res.message;
          this.img_url1 = this.$setImgUrl(res.message);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    /**点击新增 */
    handleEdit(row) {
      this.clearForm();
      if (row) {
        this.getbrankDetail(row);
      }
      this.addDrawer = true;
    },
    /**点击品牌商品 */
    handleBrand(row) {
      let prams = null;
      if (row) {
        prams = encodeURIComponent(
          JSON.stringify({ id: row.id, entId: row.entId })
        );
      }
      this.$router.push({
        path: "prefectureGoods",
        query: {
          prams: prams,
        },
      });
    },
    /**提交表单 */
    submitForm() {
      this.$refs["addForm"].validate((valid) => {
        if (valid) {
          let data = {
            type: "SaveBrand",
            name: this.addForm.name,
            linkUrl: this.addForm.imgUrl,
            img_url: this.addForm.brandImg,
            img_url_dt: this.addForm.detailsImg,
            beizhu: this.addForm.des,
            sort_id: this.addForm.sort,
            floor_id: "2",
            billno: this.addForm.id,
          };
          let proc = "Proc_Admin_Brand"; //存储过程名
          let type = "ReturnListNumber";
          this.$requestSys({
            method: "post",
            url:
              "brand/ashx/ReturnJson.ashx?type=" +
              type +
              "&json=" +
              encodeURIComponent(JSON.stringify(data)) +
              "&proc=" +
              proc,
            dataType: "json",
          })
            .then((res) => {
              if (res.flag == 0) {
                this.$message({
                  message: "提交成功",
                  type: "success",
                });
                this.getTableData();
                this.clearForm();
              } else {
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              window.console.log(err);
            });
        }
      });
    },
    /**清除表单 */
    clearForm() {
      for (let key in this.addForm) {
        this.addForm[key] = "";
      }
      this.img_url = "";
      this.img_url1 = "";
      this.addDrawer = false;
    },
  },
};
</script>

<style scoped>
.prefectureList {
  width: 100%;
  height: 100%;
}
</style>
